export const GET_CREDITS = "GET_CREDITS";
export const SET_CREDITS_AVAILABLE = "SET_CREDITS_AVAILABLE";
export const SET_CREDITS_USAGE = "SET_CREDITS_USAGE";
export const ERROR_CREDITS = "ERROR_CREDITS";
